import React from 'react';
import { Row } from 'react-bootstrap';
import {
  buildWhereForDates,
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldDateRanger,
  FieldSelectIsActive,
  TableEditButtons,
  FormCol3,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import { FieldSelectMaterialGroup, FormFieldMultiMaterialDlg } from 'shared-pages';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [{ name: likeObj }],
      };
    }
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
    if (values.materialId) {
      where = {
        ...where,
        // '$containertypesMaterials.materialId$': { $in: [JSON.parse(values.materialId)] },
        materialIds: values.materialId,
      };
    }

    // console.log('materials= ', values.materialId);
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false }) => {
  //
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    isActive: initialValues?.isActive ?? null,
    materialId: initialValues?.materialId ?? undefined,
    materialName: initialValues?.materialName ?? '',
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση ( Περιέκτες/Συσκευασίες )')}
          type="search"
          disable={disable}
        />
        <FormFieldMultiMaterialDlg
          label={t('Απόβλητα')}
          as={FormCol3}
          initValueName={filters.materialName}
          initValueId={filters.materialId}
          onValueChange={(valueId, valueName) => {
            filters.materialId = valueId;
            filters.materialName = valueName;
          }}
          initFilters={{ isActive: true }}
          disable={disable}
        />
        <FieldSelectIsActive label={t('Ενεργές Εγγραφές')} disable={disable} />
      </Row>
    </FormFilterCard>
  );
};

